var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "#74613C",
    fill: "none",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7a5 5 0 1 0 5 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.055a9 9 0 1 0 7.941 7.945"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6v3h3l3 -3h-3v-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9l-3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.0e3209e4730108404b8c86e386bc6ddb.svg";
export { ForwardRef as ReactComponent };